import { map, pick } from 'lodash';
import BigNumber from 'bignumber.js';

import FungibleTokens from 'services/fungible-tokens';
import config from 'config';
const { INDEXER_API } = config;
import { getQueryProjectsByProjectIds } from 'services/indexer/elastic-queries';

export const getNames = async (projects) => {
  return fetch(`${INDEXER_API}/projects`, {
    method: 'POST',
    body: JSON.stringify(
      getQueryProjectsByProjectIds(projects.map((item) => item.projectId))
    ),
    headers: { 'Content-type': 'application/json' }
  }).then(async (response) => {
    if (response.ok) {
      const result = await response.json();
      if (result?.hits?.hits && result.hits.hits.length > 0) {
        return result?.hits?.hits?.map((project) => {
          const stageId = projects.find(
            ({ projectId }) => projectId.toString() === project._id.toString()
          )?.projectStageId;

          const periods = project?._source?.stages[stageId]?.periods;

          return {
            projectId: project._id,
            name: project._source.name,
            periods
          };
        });
      }
      return [];
    }
    return [];
  });
};

export const getRewards = async (projects) => {
  try {
    const colGetProjectStage = await FungibleTokens.getProjectStage(
      map(projects, (item) => pick(item, ['projectId', 'projectStageId']))
    );
    const projectsStage = await Promise.all([...colGetProjectStage]);

    return projectsStage.map(
      ({ opn_rewards, total_staked_amount, minimum_staked, state }, index) => {
        const opnRewards = opn_rewards || '0';
        const stakedAmount = projects[index].stakedAmount;
        const myRewards = minimum_staked
          ? BigNumber(stakedAmount)
              .dividedBy(total_staked_amount)
              .multipliedBy(opnRewards)
              .toFixed(0)
          : '0';

        return {
          myRewards,
          minimum_staked,
          state
        };
      }
    );
  } catch (error) {
    console.error(`Failed to fetch project stage: ${error}`);
    return [];
  }
};

const getCurrentPeriod = (array) =>
  array?.findIndex(
    (period) =>
      BigInt(period.starts_at) <= BigInt(Date.now() * 1e6) &&
      BigInt(Date.now() * 1e6) < BigInt(period.ends_at)
  );

export const getProjectStatus = (project) => {
  const { periods, status, state, minimumStaked } = project;

  if (status === "'ongoingCollateral'") return 'PROVIDING COLLATERAL';
  if (state === 'Cancelled') return 'CANCELLED';
  if (state === 'Paused') return 'PAUSED';

  if (
    (state === 'Failed' || state === 'Validation' || state === 'Finished') &&
    !minimumStaked
  )
    return `FAILED MINIMUM COLLATERALIZATION`;

  if (state === 'Validation') {
    if (!periods) return 'ONGOING VALIDATION';
    const currentPeriodIndex = getCurrentPeriod(periods);

    switch (currentPeriodIndex) {
      case 0:
        return 'ONGOING VALIDATION';
      case 1:
        return 'ONGOING CHALLENGE';
      case 2:
        return 'ONGOING ESCALATION';
      case 3:
        return 'ONGOING ESCALATION';
      case 4:
        return 'ONGOING ESCALATION';
      default:
        return 'ONGOING VALIDATION';
    }
  }

  if (state === 'Finished') {
    return 'FUNDS AVAILABLE';
  }

  if (state === 'Failed') {
    return 'VALIDATION FAILED';
  }

  return 'PROVIDING COLLATERAL';
};
